import { asyncTypes } from 'store/_helpers';

const TYPES = {
  ...asyncTypes('GET_ACCOUNT'),
  ...asyncTypes('UPDATE_ACCOUNT'),
  ...asyncTypes('UPDATE_LAST_DASHBOARD_ID')
};

export default TYPES;
